// authApi.js
import { API_CONFIG} from "../../../utils/api-config";
import fetchWithAuth from "../../../utils/apiAthurization";

export const StoreIssueReceive = async (data) => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/medical-store/issue-receives`,'POST',data
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};

export const GetIssueReceives = async () => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/medical-store/issue-receives`
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "Categories fetching failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};

export const GetIssueReceiveById = async (id) => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/medical-store/issue-receives/${id}`
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};

export const UpdateIssueReceive = async (id,data) => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/medical-store/issue-receives/${id}`,'PATCH',data
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};

export const DeleteIssueReceive = async (id) => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/medical-store/issue-receives/${id}`,'DELETE'
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};